import { change, useDispatch } from '@innedit/formidable';
import { DocumentType, SuggestionType } from '@innedit/innedit-type';
import classnames from 'classnames';
import React, { FC, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import slug from 'slug';

import Button from '../Button';

const Suggestions: FC<{
  formName: string;
  query?: string;
  setQuery: (value: string) => void;
  items?: DocumentType<SuggestionType>[];
}> = ({ formName, items, query, setQuery }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleSuggestionOnClick = (
    event: SyntheticEvent<HTMLButtonElement>,
  ) => {
    const path = event.currentTarget.getAttribute('data-path');

    if (path && 'undefined' !== typeof window) {
      window.history.replaceState(
        { path },
        '',
        t('pages.recherche.pathname', { path }),
      );
      dispatch(change(formName, 'q', path));
      setQuery(path);
    }
  };
  if (query) {
    if (items) {
      return (
        <ul className="flex space-x-6 justify-center items-center content-center">
          {items.map(suggestion => (
            <li key={suggestion.id}>
              <Button
                className={classnames('whitespace-nowrap')}
                data-path={slug(suggestion.libelle)}
                onClick={handleSuggestionOnClick}
                status="link"
              >
                {suggestion.libelle}
              </Button>
            </li>
          ))}
        </ul>
      );
    }
  }

  return null;
};

export default Suggestions;
